module.exports = __webpack_public_path__ + "st.svg?3589e34b716c7cbfb519d64c63aa656c";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/st.svg
// module id = 1627
// module chunks = 0